<template>
  <div class="budgetModal">
    <el-dialog
      title="修改预算"
      :visible.sync="dialogVisible"
      width="500px"
      @close="handleClose"
    >
      <ul class="modal-form">
        <el-form :model="formData" :rules="rules" ref="ruleForm">
          <li class="form-item">
            <span class="form-label" style="padding-top: 0px">预算：</span>
            <div class="form-value">
              <el-radio-group
                v-model="formData.budget_mode"
                @change="renderRule()"
              >
                <el-radio label="BUDGET_MODE_INFINITE">不限</el-radio>
                <el-radio label="BUDGET_MODE_DAY">统一预算</el-radio>
                <el-radio label="BUDGET_MODE_DAY_SCHEDULE">分日预算</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li
            v-if="formData.budget_mode === 'BUDGET_MODE_DAY'"
            class="form-item"
            style="margin-bottom: 0px"
          >
            <span class="form-label">统一预算：</span>
            <div class="form-value">
              <el-form-item prop="day_budget">
                <el-input
                  style="width: 264px"
                  placeholder="不小于500，仅支持整数"
                  v-model="formData.day_budget"
                >
                  <template slot="append">CNY</template>
                </el-input>
              </el-form-item>
            </div>
          </li>
          <li
            v-if="formData.budget_mode === 'BUDGET_MODE_DAY_SCHEDULE'"
            class="form-item"
            style="margin-bottom: 0px"
          >
            <span class="form-label">分日预算：</span>
            <div class="form-value">
              <el-form-item prop="weekData">
                <ul class="week-wrap">
                  <li
                    class="week-item"
                    v-for="item of formData.weekData"
                    :key="item.lable"
                  >
                    <div class="week-label">{{ item.lable }}</div>
                    <div class="week-value">
                      <input
                        class="week-input"
                        v-model="item.value"
                        type="text"
                        placeholder="不小于500，仅支持整数"
                        @input="renderRule()"
                      />
                    </div>
                  </li>
                </ul>
              </el-form-item>
            </div>
          </li>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveData" :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { updateBudget } from "@/api/promotionReport.js";
export default {
  name: "BudgetModal",
  props: {
    tableType: {
      type: String,
    },
  },
  data() {
    return {
      dialogVisible: false,
      advertiserId: null,
      curId: null,
      loading: false,
      formData: {
        budget_mode: "BUDGET_MODE_DAY_SCHEDULE",
        day_budget: "",
        weekData: [
          { lable: "星期一", value: "" },
          { lable: "星期二", value: "" },
          { lable: "星期三", value: "" },
          { lable: "星期四", value: "" },
          { lable: "星期五", value: "" },
          { lable: "星期六", value: "" },
          { lable: "星期日", value: "" },
        ],
      },
      rules: {
        day_budget: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (value === null || value === "") {
                callback(new Error("统一预算必填"));
              } else if (
                !/^[1-9]*[1-9][0-9]*$/.test(value) ||
                Number(value) < 500
              ) {
                callback(new Error("请输入不小于500的整数"));
              } else {
                callback();
              }
            },
          },
        ],
        weekData: [
          {
            trigger: ["blur", "change"],
            type: "arr",
            validator: (rule, value, callback) => {
              for (let i = 0; i < value.length; i++) {
                let curItem = value[i];
                if (!curItem.value) {
                  callback(new Error("分日预算填写不完整"));
                  break;
                } else if (
                  !/^[1-9]*[1-9][0-9]*$/.test(curItem.value) ||
                  Number(curItem.value) < 500
                ) {
                  callback(new Error("请输入不小于500的整数"));
                  break;
                }
              }
              callback();
            },
          },
        ],
      },
    };
  },
  methods: {
    showModal(rowData) {
      this.advertiserId = rowData.advertiser_id;
      this.curId = 1;
      console.log(rowData);
      this.formData.budget_mode = rowData.budget_mode;
      if (rowData.budget_mode === "BUDGET_MODE_DAY") {
        this.formData.day_budget = rowData.budget;
      } else if (rowData.budget_mode === "BUDGET_MODE_DAY_SCHEDULE") {
        this.formData.weekData.forEach((item, index) => {
          item.value = rowData.dayBudgetSchedule[index];
        });
      }
      this.dialogVisible = true;
    },
    handleClose() {
      this.$refs.ruleForm.resetFields();
      this.$refs.ruleForm.clearValidate();
    },
    renderRule() {
      this.$refs.ruleForm.validate();
    },
    saveData() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = {
            advertiserId: this.advertiserId,
            budgetMode: this.formData.budget_mode,
          };
          if (this.formData.budget_mode === "BUDGET_MODE_DAY") {
            params.budget = this.formData.day_budget * 1000;
          } else if (this.formData.budget_mode === "BUDGET_MODE_DAY_SCHEDULE") {
            params.budget = this.formData.weekData
              .map((item) => item.value * 1000)
              .join();
          }
          switch (this.tableType) {
            case "adCount":
              params.type = 1;
              break;
            case "plan":
              params.type = 2;
              break;
            case "adGroup":
              params.type = 3;
              break;
            default:
              break;
          }
          this.loading = true;
          updateBudget(params).then((res) => {
            this.loading = false;
            if (res.code === "0000") {
              this.$message({
                message: "预算修改成功",
                type: "success",
              });
              this.dialogVisible = false;
              this.$emit("refreshData");
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.modal-form {
  margin: 0px;
  padding: 0px;
  list-style: none;
  .form-item {
    display: flex;
    margin-bottom: 16px;
    /deep/ .el-form-item {
      margin-bottom: 6px;
    }
    .form-label {
      flex-shrink: 0;
      display: inline-block;
      width: 100px;
      text-align: right;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      padding-top: 6px;
    }
    .form-value {
      width: 100%;
      padding-top: 2px;
      /deep/ .el-radio__input.is-checked .el-radio__inner {
        color: rgba(24, 144, 255, 1);
        border-color: rgba(24, 144, 255, 1);
        background: rgba(24, 144, 255, 1);
      }
      /deep/ .el-radio__input.is-checked + .el-radio__label {
        color: rgba(24, 144, 255, 1);
      }
      /deep/ .el-input-group__append,
      /deep/ .el-input-group__prepend {
        background-color: #fff;
        color: rgba(0, 0, 0, 0.85);
        padding: 0 10px;
      }
      .week-wrap {
        padding: 0px;
        margin: 0px;
        list-style: none;
        // border: 1px solid rgb(238, 238, 238);
        // display: flex;
        // flex-direction: column;
        // width: 616px;
        // height: 70px;
        .week-item {
          display: inline-block;
          width: 100%;
          border-right: 1px solid rgb(238, 238, 238);
          box-sizing: border-box;
          display: flex;
          align-items: center;
          border: 1px solid rgb(238, 238, 238);
          margin-bottom: 10px;
          .week-label {
            height: 32px;
            width: 100px;
            flex-shrink: 0;
            line-height: 32px;
            text-align: center;
            font-size: 12px;
            background-color: #f7f7f7;
          }
          .week-value {
            height: 32px;
            width: 100%;
            display: flex;
            .week-input {
              display: block;
              height: 100%;
              box-sizing: border-box;
              outline: none;
              // text-align: center;
              border: none;
              padding-left: 10px;
            }
          }
        }
        .week-item:last-child {
          border-right: none;
        }
      }
      .count-select {
        .el-select-dropdown__item {
          height: 45px;
          line-height: 45px;
        }
        .count-option {
          font-size: 12px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 100%;
          .count-item {
            display: block;
            line-height: 20px;
          }
        }
      }
    }
  }
}
</style>